import Image from 'next/image';
import Link from 'next/link';
import React from 'react';

const VillaRentalAreas = () => (
  <div className="flex flex-col">
    <span className="text-[#586474] font-extrabold leading-normal mb-4">
      Villa Kiralama Bölgeleri
    </span>
    {[...Array(3)].map((_, index) => (
      <Link
        key={index}
        href="link"
        prefetch={false}
        className="rounded-md bg-white p-3 mb-2 border-2 border-[#ced8e7] block"
      >
        <div className="flex items-center gap-4">
          <Image
            src="/621_mugla.jpg"
            width={100}
            height={60}
            className="rounded-md flex-shrink-0 overflow-hidden"
            alt="Villa"
          />
          <div className="flex flex-col gap-2">
            <span className="text-sm text-black font-semibold">
              Muğla Kiralama Bölgeleri
            </span>
            <span className="text-xs text-[#5d6782]">705 Villa</span>
          </div>
        </div>
      </Link>
    ))}
  </div>
);

export default VillaRentalAreas;
